import { combineReducers } from "redux";
import authUser, { clearAuthUser, logout } from "./authUserSlice.js";
import PBICredSlice from "./PBICredSlice.js";
import PBILoadedSlice from "./PBILoadedSlice.js";

const appReducer = combineReducers({
  authUser: authUser,
  PBICred: PBICredSlice,
  PBILoaded: PBILoadedSlice,
});

// Actions that mean "the user session is gone" - reset every slice back to its
// initialState so no data (e.g. PBICred) can leak across login/logout.
const RESET_ON_ACTIONS = [clearAuthUser.type, logout.fulfilled.type];

const rootReducer = (state, action) => {
  if (RESET_ON_ACTIONS.includes(action.type)) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
